import type {
    FarmDetailsType,
    FarmListApiParamsType,
    FarmListReturnType,
    FarmUserType,
} from "@/types/farm-type";
import { api, mpApi } from "./api";
import type { BasicResponse, DataResponse } from "@/types/auth-type";
import type { FarmFormData } from "@/schemas/farm-schema";
import { buildFarmFormData } from "@/utils/api-func";

export async function farmListRequest(
    params: FarmListApiParamsType,
): Promise<FarmListReturnType> {
    const res = await api.get("/farm", { params });
    return res.data;
}

export async function birdTypeListRequest(): Promise<string[]> {
    const res = await api.get("/farm/bird-types");
    return res.data;
}

export async function farmsDetailRequest(
    slug: string,
): Promise<FarmDetailsType> {
    const res = await api.get(`/farm/${slug}`);
    return res.data;
}

export async function getFarmUserRequest(): Promise<
    DataResponse<FarmUserType[]>
> {
    const res = await api.get("/user/farm");
    return res.data;
}

export async function createFarmRequest(
    data: FarmFormData,
): Promise<DataResponse<FarmUserType>> {
    const fd = buildFarmFormData(data);
    const res = await mpApi.post("/user/farm", fd);
    return res.data;
}

export async function editFarmRequest(
    id: number | string,
    data: FarmFormData,
): Promise<DataResponse<FarmUserType>> {
    const fd = buildFarmFormData(data);
    fd.append("_method", "PUT");
    const res = await mpApi.post(`/user/farm/${id}`, fd);
    return res.data;
}

export async function deleteFarmRequest(
    id: number | string,
): Promise<BasicResponse> {
    const res = await api.delete(`/user/farm/${id}`);
    return res.data;
}
